import { StoreEvent } from '../../enums/storeEvent';
import { useQuote } from '../../store/selectors/useQuote';
import { store } from '../../store/store';
import { QuotePageSubs } from './QuotePageSubs/QuotePageSubs';
import { QuoteReplacementCare } from './QuoteReplacementCare/QuotePageReplacementCare';

/**
 * @description The QuotePage component is responsible for rendering the appropriate quote page based on the contract attributes of the quote data.
 */
export const QuotePage = () => {
  const quote = useQuote();
  const quoteData = quote?.data;
  const brand = import.meta.env.VITE_CLIENT_FRIENDLY_NAME;

  if (!quoteData || Object.keys(quoteData).length === 0) {
    store.send({ type: StoreEvent.QUOTE_ERROR });
    return null;
  }

  return (
    <div className="flex flex-col justify-center items-center bg-bg-main max-h-full">
      <div className="max-w-300 h-auto flex flex-col justify-center gap-space-500 rounded-radius-100">
        {quoteData?.offer?.contracts[0]?.contractAttributes?.fixed_term_single_payment ? (
          <QuoteReplacementCare brand={brand} />
        ) : (
          <QuotePageSubs brand={brand} />
        )}
      </div>
    </div>
  );
};
